import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoyaltyService } from 'src/app/services/loyalty.service';
import { LoyaltyCardResponse } from 'src/app/models/loyalty.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-loyalty-register',
  templateUrl: './loyalty-register.component.html',
  styleUrls: ['./loyalty-register.component.scss'] // Usas scss según la imagen
})
export class LoyaltyRegisterComponent implements OnInit {

  registerForm!: FormGroup;
  loading = false;
  createdCard: LoyaltyCardResponse | null = null;

  constructor(
    private fb: FormBuilder,
    private loyaltyService: LoyaltyService
  ) { }

  ngOnInit(): void {
    // Verificar si el cliente ya tiene tarjeta guardada en el teléfono
    const savedCard = localStorage.getItem('loyalty_card');
    if (savedCard) {
      this.createdCard = JSON.parse(savedCard);
    }

    this.registerForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]{8,15}$')]]
    });
  }

  onSubmit(): void {
    if (this.registerForm.invalid) return;

    this.loading = true;
    this.loyaltyService.registerPublicCustomer(this.registerForm.value).subscribe({
      next: (card) => {
        this.loading = false;
        this.createdCard = card;
        localStorage.setItem('loyalty_card', JSON.stringify(card));
      },
      error: () => {
        this.loading = false;
        alert('Ocurrió un error al registrar tu tarjeta. Inténtalo de nuevo.');
      }
    });
  }

    resetForm(): void {
    this.createdCard = null;
    this.registerForm.reset();
    localStorage.removeItem('loyalty_card'); // Borra la tarjeta de la memoria
  }

downloadAppleWallet(): void {
    if (!this.createdCard) return;
    
    // Obtenemos el ID leyendo dentro de 'data'
    const targetId = (this.createdCard as any).data.idCard;
    
    // Limpiamos la URL base y redirigimos
    const baseUrl = environment.api.endsWith('/') ? environment.api.slice(0, -1) : environment.api;
    window.location.href = `${baseUrl}/api/erp/loyalty-card/public/wallet/apple/${targetId}`;
  }

  openGoogleWallet(): void {
    if (!this.createdCard) return;

    // Obtenemos el ID leyendo dentro de 'data'
    const targetId = (this.createdCard as any).data.idCard;

    // Limpiamos la URL base y redirigimos
    const baseUrl = environment.api.endsWith('/') ? environment.api.slice(0, -1) : environment.api;
    window.location.href = `${baseUrl}/api/erp/loyalty-card/public/wallet/google/${targetId}`;
  }
}